import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ComparePricesIllustration.tsx
const ComparePricesIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "compare-prices.svg",
		alt: t("illustration.imageAlt.comparePrices")
	});
};

//#endregion
export { ComparePricesIllustration };